"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the name for the provided catalog
 *
 * @param items - The list of CatalogItems to search
 * @param code - The code that will be searched for
 */
function catalogNameForCode(items, code) {
    var foundItem = items.filter(function (item) { return item.code === code; }).pop();
    if (foundItem) {
        return foundItem.name;
    }
    return 'not found';
}
exports.default = catalogNameForCode;
//# sourceMappingURL=catalogNameForCode.js.map